<div class="get-started"><xqnr-get-started-form (formCancel)="formCancel()"></xqnr-get-started-form></div>